<script setup>
import { ref, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import { Collapse, CollapseItem, Empty } from 'vant'
import { getAnswerRecordList } from '@/api/admin'
import Record from './Record.vue'
import ExportBtn from './ExportBtn.vue'

const props = defineProps({
  formTree: {
    type: Object,
    default: () => {},
  },
  recordType: Number,
  formDate: Object,
})

const activeNames = ref([])
const route = useRoute()

const recordList = ref([])
const recordLoading = ref(true)
// 获取答题记录列表
const fetchAnswerList = async () => {
  recordLoading.value = false

  const res = await getAnswerRecordList({
    questionActiveKey: route.query.questionActiveKey,
    // pageNum: 1,
    // pageSize: 10,
    recordType: props.recordType,
    ...props.formTree,
    ...props.formDate,
  })

  if (res.ok) {
    recordList.value = [...res.data.rows]
  }

  recordLoading.value = false
}

watchEffect(() => {
  fetchAnswerList()
})
</script>
<template>
  <!-- 导出按钮 -->
  <ExportBtn
    :formTree="formTree"
    :recordType="recordType"
    :formDate="formDate"
  />
  <div class="record-list-wrap">
    <Collapse class="list" v-model="activeNames">
      <Collapse-item
        class="item"
        v-for="(item, index) in recordList"
        :name="index + 1"
      >
        <template #title>
          <div class="item-title">
            <span class="name">{{ item?.name }}</span>
            <span class="count"
              >已填<strong>{{ item?.count }}</strong
              >条</span
            >
          </div>
        </template>
        <Record :record="item" />
      </Collapse-item>
    </Collapse>
  </div>
  <Empty v-show="!recordLoading && recordList.length === 0" />
</template>
<style lang="scss" scoped>
.record-list-wrap {
  padding: 0 25px;
  padding-top: 20px;
  background-color: #f1f3f5;

  .list {
    background-color: #f1f3f5;

    ::v-deep {
      .van-cell {
        position: relative;
        padding: 0;

        .van-cell__right-icon {
          position: absolute;
          top: 0;
          bottom: 0;
          right: 10px;
          margin: auto;
          color: #333333;
          font-size: 20px;
        }
      }
    }

    .item {
      margin-bottom: 20px;
      border-radius: 10px;
      background-color: #fff;

      .item-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        height: 98px;
        padding: 24px 30px;

        span.name {
          font-weight: bold;
          font-size: 34px;
          color: #222222;
        }

        span.count {
          margin-right: 51px;
          font-size: 34px;

          strong {
            margin: 0 10px;
            color: #387eff;
          }
        }
      }
    }
  }
}
/* ::deep {
  .van-collapse-item {
    margin-bottom: 10px;
  }
} */
</style>
